import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const AUTHOR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/4add1500-1c8f-4f9b-ab9c-6731d423bceb.jpg';
export function Guarantee() {
  return <section className="w-full bg-ink" data-id="element-52" data-mp="223og3m26g4fh">
      <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-10 px-5 py-20 sm:px-8 lg:grid-cols-[auto_1fr] lg:gap-14 lg:py-24" data-id="element-53" data-mp="222n0d4a7utrf">
        <img src={AUTHOR_IMAGE} alt="Portrait of the coach behind The HYROX Coach Blueprint" className="h-40 w-40 rounded-full object-cover grayscale lg:h-56 lg:w-56" data-id="element-54" data-mp="19e7p8su7gvld" />
        <div data-id="element-55" data-mp="14dtf9591nbkp">
          <p className="flex items-center gap-2 font-sans text-xs font-semibold uppercase tracking-[0.22em] text-volt" data-id="element-56" data-mp="1j4k7ufigmeov">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="1edc0dp0ox3ec" />
            100% risk-free
          </p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-58" data-mp="qnhp3bw0rmw7">
            The “Podium” guarantee
          </h2>
          <p className="mt-6 font-sans text-lg leading-relaxed text-muted" data-id="element-59" data-mp="p01j2cs0vbcd">
            I am so confident this method will transform your coaching that I’m
            taking all the risk. Use the Blueprint for 7 days. If you don’t feel
            it’s the most valuable resource you’ve ever bought for your coaching
            career, just send me an email.{' '}
            <span className="font-semibold text-white" data-id="element-60" data-mp="12sr52h7jwg9h">
              I’ll refund every cent. No questions asked.
            </span>
          </p>
        </div>
      </div>
    </section>;
}